const auxx = (props) => props.children;

export default auxx;